import { Button } from '@starsoft/common/components';
import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';

export default function SecurityDrawerContentSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.container__card}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            className={styles.container__card__row}
            key={`security_content_details_${i}`}
          >
            <div className={skeleton.label} />
            <div className={skeleton.label} />
          </div>
        ))}
      </div>

      <Button isSkeleton />
    </div>
  );
}
